// Register <cart-drawer> so Dawn's native product-form.js (used on product pages)
// recognizes our drawer and opens it instead of doing a full-page redirect to /cart.
if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', class extends HTMLElement {
    getSectionsToRender() { return []; }
    setActiveElement() {}
    renderContents() {
      if (typeof window.higumaOpenCart === 'function') window.higumaOpenCart();
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('site-header');
  if (header) { window.addEventListener('scroll', () => { header.classList.toggle('scrolled', window.scrollY > 20); }, { passive: true }); }

  const burgerBtn = document.getElementById('burger-btn');
  const sideMenu = document.getElementById('side-menu');
  const menuOverlay = document.getElementById('menu-overlay');
  const menuClose = document.getElementById('menu-close');

  function openMenu() { sideMenu?.classList.add('open'); menuOverlay?.classList.add('open'); burgerBtn?.classList.add('active'); document.body.style.overflow = 'hidden'; }
  function closeMenu() { sideMenu?.classList.remove('open'); menuOverlay?.classList.remove('open'); burgerBtn?.classList.remove('active'); document.body.style.overflow = ''; }
  burgerBtn?.addEventListener('click', openMenu);
  menuClose?.addEventListener('click', closeMenu);
  menuOverlay?.addEventListener('click', closeMenu);

  const searchBtn = document.getElementById('search-btn');
  const searchOverlay = document.getElementById('search-overlay');
  const searchClose = document.getElementById('search-close');
  const searchInput = document.getElementById('search-input');
  function openSearch() { searchOverlay?.classList.add('open'); document.body.style.overflow = 'hidden'; setTimeout(() => searchInput?.focus(), 100); }
  function closeSearch() { searchOverlay?.classList.remove('open'); document.body.style.overflow = ''; }
  searchBtn?.addEventListener('click', openSearch);
  searchClose?.addEventListener('click', closeSearch);

  const cartBtn = document.getElementById('cart-btn');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose = document.getElementById('cart-close');
  const cartCount = document.getElementById('cart-count');

  function openCart() { cartDrawer?.classList.add('open'); cartOverlay?.classList.add('open'); document.body.style.overflow = 'hidden'; refreshCartDrawer(); }
  function closeCart() { cartDrawer?.classList.remove('open'); cartOverlay?.classList.remove('open'); document.body.style.overflow = ''; }
  window.higumaOpenCart = openCart;
  cartBtn?.addEventListener('click', openCart);
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);
  document.addEventListener('click', (e) => { if (e.target.closest('#cart-continue')) closeCart(); });

  cartDrawer?.addEventListener('wheel', (e) => {
    const itemsEl = document.getElementById('cart-items');
    if (!itemsEl) return;
    if (e.target.closest('#cart-items')) return;
    itemsEl.scrollTop += e.deltaY;
    e.preventDefault();
  }, { passive: false });

  function formatMoney(cents) { return '€' + (cents/100).toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

  async function addToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity }] })
    });
    const data = await res.json();
    if (!res.ok) {
      const msg = (data && (data.description || data.message)) || 'Could not add item to cart.';
      throw new Error(msg);
    }
    return data;
  }

  async function loadUpsell(cart) {
    const upsellEl = document.getElementById('cart-upsell');
    if (!upsellEl) return;
    if (!cart.items.length) { upsellEl.innerHTML = ''; return; }
    const cartProductIds = new Set(cart.items.map(i => i.product_id));
    const anchorId = cart.items[cart.items.length - 1].product_id;
    try {
      const res = await fetch('/recommendations/products.json?product_id=' + anchorId + '&limit=6&intent=related');
      const data = await res.json();
      const pick = (data.products || []).find(p => !cartProductIds.has(p.id) && p.available);
      if (!pick) { upsellEl.innerHTML = ''; return; }
      const img = pick.featured_image || (pick.images && pick.images[0]) || '';
      const variantId = (pick.variants && pick.variants[0]) ? pick.variants[0].id : '';
      const price = typeof pick.price === 'number' ? formatMoney(pick.price) : pick.price;
      upsellEl.innerHTML = `
        <div class="cart-upsell-card">
          <a href="${pick.url}">${img ? `<img class="cart-upsell-img" src="${img}&width=120" alt="">` : ''}</a>
          <div class="cart-upsell-info">
            <a href="${pick.url}" class="cart-upsell-name">${pick.title}</a>
            <div class="cart-upsell-price">${price}</div>
          </div>
          <button class="cart-upsell-add" data-variant-id="${variantId}">ADD</button>
        </div>`;
    } catch (e) { upsellEl.innerHTML = ''; }
  }

  async function refreshCartDrawer() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      if (cartCount) { cartCount.textContent = cart.item_count; cartCount.dataset.count = cart.item_count; }
      const itemsEl = document.getElementById('cart-items');
      const footerEl = document.getElementById('cart-footer-wrap');
      const totalEl = document.getElementById('cart-total');
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      if (!itemsEl) return;
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p><a href="/collections/all" class="cart-checkout-btn" style="display:inline-block;width:auto;padding:0.9rem 2rem">Start Shopping</a></div>';
      } else {
        itemsEl.innerHTML = cart.items.map(item => `
          <div class="cart-item" data-key="${item.key}">
            <a href="${item.url}">${item.image ? `<img class="cart-item-img" src="${item.image}&width=160" alt="" width="80" height="107">` : '<div class="cart-item-img"></div>'}</a>
            <div class="cart-item-body">
              <div class="cart-item-top">
                <div class="cart-item-title">${item.product_title}</div>
                <button class="cart-item-remove" data-key="${item.key}" aria-label="Remove">&times;</button>
              </div>
              <div class="cart-item-variant">${(item.variant_title || '').split(' / ').join(', ')}</div>
              <div class="cart-item-bottom">
                <div class="cart-item-qty">
                  <button class="qty-btn" data-action="decrease" data-key="${item.key}">−</button>
                  <span class="qty-num">${item.quantity}</span>
                  <button class="qty-btn" data-action="increase" data-key="${item.key}">+</button>
                </div>
                <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
              </div>
            </div>
          </div>`).join('') + '<div class="cart-upsell" id="cart-upsell"></div>';
        loadUpsell(cart);
      }
      if (footerEl) footerEl.style.display = '';
    } catch (e) { console.error('Higuma cart refresh failed:', e); }
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.product-atc-btn, .look-item-add, .ctl-add-btn, .cart-upsell-add');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId || variantId === '' || btn.disabled) {
      console.error('Higuma: quick-add button has no valid variant id', btn);
      return;
    }
    const original = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;
    try {
      await addToCart(variantId, 1);
      btn.textContent = btn.classList.contains('cart-upsell-add') ? '✓' : (btn.classList.contains('ctl-add-btn') ? '✓ ADDED' : 'Added ✓');
      btn.classList.add('added');
      setTimeout(() => { if (document.body.contains(btn)) { btn.textContent = original; btn.classList.remove('added'); btn.disabled = false; } }, 1200);
    } catch (err) {
      console.error('Higuma: add to cart failed:', err.message);
      btn.textContent = 'Sold Out';
      setTimeout(() => { if (document.body.contains(btn)) { btn.textContent = original; btn.disabled = false; } }, 2500);
    } finally {
      openCart();
    }
  });

  document.addEventListener('click', async (e) => {
    const qtyBtn = e.target.closest('.qty-btn');
    if (qtyBtn) {
      const key = qtyBtn.dataset.key;
      const action = qtyBtn.dataset.action;
      const qtyEl = qtyBtn.parentElement.querySelector('.qty-num');
      let qty = parseInt(qtyEl?.textContent || '1');
      if (action === 'increase') qty++; else qty = Math.max(0, qty - 1);
      try {
        await fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
        refreshCartDrawer();
      } catch (err) { console.error('Higuma cart change failed:', err); }
      return;
    }
    const removeBtn = e.target.closest('.cart-item-remove');
    if (removeBtn) {
      const key = removeBtn.dataset.key;
      try {
        await fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
        refreshCartDrawer();
      } catch (err) { console.error('Higuma cart remove failed:', err); }
    }
  });

  const catsScroll = document.getElementById('cats-scroll');
  if (catsScroll) {
    let isDown = false, startX, scrollLeft;
    catsScroll.addEventListener('mousedown', e => { isDown = true; startX = e.pageX - catsScroll.offsetLeft; scrollLeft = catsScroll.scrollLeft; });
    catsScroll.addEventListener('mouseleave', () => isDown = false);
    catsScroll.addEventListener('mouseup', () => isDown = false);
    catsScroll.addEventListener('mousemove', e => { if (!isDown) return; e.preventDefault(); const x = e.pageX - catsScroll.offsetLeft; catsScroll.scrollLeft = scrollLeft - (x - startX) * 1.4; });
  }

  const playBtn = document.getElementById('about-play-btn');
  const aboutVideo = document.getElementById('about-video');
  const videoWrap = document.getElementById('about-video-wrap');
  playBtn?.addEventListener('click', () => { if (aboutVideo) { aboutVideo.play(); aboutVideo.muted = false; videoWrap?.classList.add('playing'); } });

  document.addEventListener('keydown', e => { if (e.key !== 'Escape') return; closeMenu(); closeSearch(); closeCart(); });

  // ---- Product page: "Size Chart" jump-link next to the Size label,
  // placed as a SIBLING in a flex row so it can never overlap the label. ----
  const sizeLabel = Array.from(document.querySelectorAll('.product-form__input .form__label')).find(el => /size/i.test(el.textContent) && !/color/i.test(el.textContent));
  const sizeChartSection = document.querySelector('.size-chart__accordion');
  if (sizeLabel && sizeChartSection && !document.querySelector('.higuma-size-guide-link')) {
    const row = document.createElement('div');
    row.className = 'higuma-size-guide-row';
    const link = document.createElement('a');
    link.href = '#';
    link.className = 'higuma-size-guide-link';
    link.textContent = 'Size Chart';
    link.addEventListener('click', (e) => {
      e.preventDefault();
      sizeChartSection.setAttribute('open', '');
      sizeChartSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    sizeLabel.parentNode.insertBefore(row, sizeLabel);
    row.appendChild(sizeLabel);
    row.appendChild(link);
  }
});
